import React, { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'; // Importe useSelector
import { fetchConfig } from './redux/configSlice';
import { updateUser, clearUser } from './redux/userSlice';
import API from './api';
// Layouts
import AppLayout from './layouts/AppLayout';
// Routes Components
import HomeDefault from './components/homes/HomeDefault';
import HomeMain from './components/homes/HomeMain';
import Catalog from './components/products/Catalog';
import Cart from './components/cart/Cart';
import DeliverySelect from './components/deliveries/DeliverySelect';
import OrderFinalize from './components/orders/OrderFinalize';
import Orders from './components/orders/Orders';
import Order from './components/orders/Order';
import Faq from './components/faq/Faq';
import Thread from './components/faq/Thread';
import AdminHome from './components/homes/AdminHome';
import CustomerAccount from './components/customers/CustomerAccount';
import AdminCustomersList from './components/customers/admin/AdminCustomersList';
import AdminOrdersList from './components/orders/admin/AdminOrdersList';
import AdminProductsList from './components/products/admin/AdminProductsList';
// Styles 
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './css/app.css';
import ProductsList from './components/products/ProductsList';
// Route Definitions
const routes = [
  { path: "/", element: <HomeDefault /> },
  { path: "/home", element: <HomeMain />, requireAuth: true },
  { path: "/cart", element: <Cart />, requireAuth: true },
  { path: "/catalog", element: <ProductsList />, requireAuth: true },
  { path: "/orders", element: <Orders />, requireAuth: true },
  { path: "/order/:id", element: <Order />, requireAuth: true },
  { path: "/cust/account", element: <CustomerAccount />, requireAuth: true },
  { path: "/faq", element: <Faq />, requireAuth: true },
  { path: "/faq/:ref", element: <Thread />, requireAuth: true },
  { path: "/orderFinalize", element: <OrderFinalize />, requireAuth: true },
  { path: "/deliverySelect/:orderId", element: <DeliverySelect />, requireAuth: true },
  { path: "/extradmin", element: <AdminHome />, requireAdmin: true },
  { path: "/extradmin/customers", element: <AdminCustomersList />, requireAdmin: true },
  { path: "/extradmin/customers/:id", element: <AdminCustomersList />, requireAdmin: true },
  { path: "/extradmin/orders", element: <AdminOrdersList />, requireAdmin: true },
  { path: "/extradmin/products", element: <AdminProductsList />, requireAdmin: true },
  { path: "/extradmin/products/:id", element: <AdminProductsList />, requireAdmin: true },
  { path: "*", element: <HomeDefault /> },
];
function App() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const configStatus = useSelector((state) => state.config.status);
  const [allowed, setAllowed] = useState(false);
  const spinner = (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
        <div className="mt-3">
          Chargement de la configuration…
        </div>
      </div>
    </div>
  );
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const adminAuthToken = params.get('adminAuthToken');
    if (adminAuthToken) {
      checkToken(adminAuthToken, params.get('userId'));
    } else {
      setAllowed(true);
    }
    // Setup message listener
    const handleMessage = (event) => {
      //      console.log('Received message:', event.data.type);
      if (event.data && event.data.type === 'userSignOut') {
        dispatch(clearUser());
      }
    };
    window.addEventListener("message", handleMessage);
    // Cleanup listener on unmount
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  useEffect(() => {
    const isAdmin = window.location.pathname.startsWith('/extradmin');
    dispatch(fetchConfig({ isAdmin }));
  }, [dispatch]);
  const checkToken = async (adminAuthToken, userId) => {
    let querystring = 'adminAuthToken=' + adminAuthToken;
    querystring += '&userId=' + userId;
    console.log('/admin/signin?' + querystring);
    const response = await API.get('/admin/signin?' + querystring);
    if (response.data.isAdmin == true) {
      setAllowed(true)
      window.localStorage.setItem('adminToken', response.data.token);
      dispatch(updateUser(response.data));
      window.sessionStorage.setItem('backoffice_url', '/appAdmin');
      window.location.href = '/extradmin';
    } else {
      window.location.href = '/';
    }
  }
  if (configStatus === 'idle' || configStatus === 'loading') {
    return spinner;
  }
  if (configStatus === 'failed') {
    return null;
  }
  console.log('configStatus', configStatus)
  if (configStatus !== 'succeeded' || !allowed) {
    return spinner;
  }
  return (


    <Router>
      <Routes>
        {routes.map((route) => (
          <Route key={route.path}
            path={route.path}
            element={<AppLayout requireAuth={route.requireAuth} requireAdmin={route.requireAdmin} >
              {route.element}
            </AppLayout>}
          />
        ))}
      </Routes>
    </Router>


  );
}
export default App;
